import React from 'react';
import Header from '../../component/header/header';
import Footer from '../../component/footer/footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { motion } from 'framer-motion';
import './about.css';

const About = () => {
  return (
    <div>
      <Header />

      {/* Hero Section */}
      <section className="about-hero d-flex align-items-center justify-content-center">
        <div className="hero-overlay" />
        <Container className="text-center hero-content">
          <motion.h1
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="hero-title"
          >
            About Our Startup
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="hero-sub"
          >
            Driving innovation and growth in the modern business world.
          </motion.p>
        </Container>
      </section>

      {/* Mission Section */}
      <section className="mission-section py-5">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <motion.img
                src="/images/in-1.jpg"
                alt="Our Mission"
                className="img-fluid rounded"
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
              />
            </Col>
            <Col md={6}>
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
              >
                <h2>Our Mission</h2>
                <p>
                  Our mission is to empower startups and entrepreneurs to scale
                  their business, innovate fearlessly, and achieve sustainable
                  growth through modern business strategies and cutting-edge
                  solutions.
                </p>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Vision Section */}
      <section className="vision-section py-5 bg-light">
        <Container>
          <Row className="align-items-center flex-column-reverse flex-md-row">
            <Col md={6}>
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
              >
                <h2>Our Vision</h2>
                <p>
                  We envision a world where every startup has the tools,
                  knowledge, and mentorship to turn ideas into successful
                  businesses. We strive to create an ecosystem of growth,
                  innovation, and collaboration.
                </p>
              </motion.div>
            </Col>
            <Col md={6}>
              <motion.img
                src="/images/in-3.jpg"
                alt="Our Vision"
                className="img-fluid rounded"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Team Section */}
      <section className="team-section py-5">
        <Container>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-5"
          >
            Meet Our Team
          </motion.h2>
          <Row className="g-4">
            {[1,2,3,4].map((member)=> (
              <Col key={member} xs={12} md={6} lg={3}>
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.98 }}
                  className="team-card-wrap"
                >
                  <Card className="team-card h-100 shadow-lg">
                    <Card.Img variant="top" src={'./images/t-1.jpg'} className="rounded" />
                    <Card.Body className="text-center">
                      <Card.Title>Member {member}</Card.Title>
                      <Card.Text>Co-Founder & CEO</Card.Text>
                      <Button variant="primary">Connect</Button>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="cta-section py-5 bg-primary text-white text-center">
        <Container>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >Join Our Journey</motion.h2>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            Be a part of our innovative startup ecosystem. Connect with us and grow together.
          </motion.p>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            <Button variant="light" size="lg">Get Involved</Button>
          </motion.div>
        </Container>
      </section>

      {/* secound section */}

      

      <Footer />
    </div>
  );
}

export default About;